<template>
    <div>
        <div v-if="$wait.is('fetching preview resource')" class="loading">
            <Spinner :height="40" :width="40"/>
        </div>
        <ul class="league-table" v-else-if="resource && resource.items.length > 0">
            <li v-for="(item, index) in resource.items" class="league-table__item">
                <div :class="['league-position', `league-position--${item.direction}`]">
                    <div class="league-position__rank" v-text="index + 1"/>
                    <div class="league-position__person">
                        <UserCard
                            v-if="item.user"
                            :user="item.user"
                            :borderless="true"
                            :tiny="true"
                        />
                    </div>
                </div>
            </li>
        </ul>
        <h3 v-else >No Data</h3>
        <span class="last-updated" v-if="resource && resource.last_updated">Last updated: {{ resource.last_updated }}</span>
    </div>
</template>
<script>
import API from '@api';
import ResourcePreview from '@components/ResourcePreview';
import Spinner from '@components/Spinner';
import UserCard from '@components/User/UserCard';

export default {
    name: 'SectorLeagueTable',
    components: {
        UserCard,
        Spinner,
    },
    mixins: [ResourcePreview],
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            resource: null,
        }
    },
    methods: {
        async fetchResource() {
            try {
                return await API.getSectorLeagueTable(this.id);
            } catch(err) {
                console.warn({err});
            }
        },
    },
}
</script>
<style lang="scss">
@import '~@/theme/_variables.scss';

.loading {
    min-height: 12rem;
}

.league-table {
    padding: 0;
    margin: 0;
    list-style: none;

    .league-table__item {
        padding: 1rem 0;

        + .league-table__item {
            border-top: .1rem solid $border;
        }
    }
}

.league-position {
    display: flex;
    align-items: center;
    column-gap: 1rem;

    .league-position__rank {
        flex: 0 0 3rem;
        display: flex;
        align-items: center;
        column-gap: .5rem;

        &:before {
            content: "";
            background-color: #ADB6BF;
            width: 8px;
            height: 2px;
            display: block;
        }
    }

    .league-position__person {
        flex: 0 0 calc(100% - 4rem);
        max-width: calc(100% - 4rem);

        .card__content {
            flex: 1;
            min-width: 0;

            p {
                font-size: 1.2rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }


    &.league-position--increase .league-position__rank:before {
        height: 0;
        width: 0;
        border-bottom: .5rem solid green;
        border-left: .4rem solid transparent;
        border-right: .4rem solid transparent;
        background-color: transparent;
    }

    &.league-position--decrease .league-position__rank:before {
        height: 0;
        width: 0;
        border-top: .5rem solid red;
        border-left: .4rem solid transparent;
        border-right: .4rem solid transparent;
        background-color: transparent;
    }
}

.last-updated {
    color: $secondary;
    font-size: 1rem;
    display: block;
    margin-top: .5rem;
}
</style>
